import { RequiredDocumentFormValues } from '../helpers';
import { useGetRequiredRule, useLengthValidationRule } from '@/hooks';
import { useTranslation } from 'react-i18next';

export const useGetRequiredDocumentRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const lengthRule = useLengthValidationRule({ t, max: 150 });

  return {
    [RequiredDocumentFormValues.DESCRIPTION_EN]: [requiredRule, lengthRule],
    [RequiredDocumentFormValues.DESCRIPTION_NO]: [requiredRule, lengthRule],
    [RequiredDocumentFormValues.NAME_EN]: [requiredRule],
    [RequiredDocumentFormValues.NAME_NO]: [requiredRule],
  };
};
